module.exports = __webpack_public_path__ + "img/HHdszorolap2023.67b2c44e.jpg";